import { Content } from "./styles";

const SectionContainer = ({
  backgroundImage,
  children,
  id,
  backgroundPosition,
  flexDirection = "column-reverse",
  padding,
}) => {
  return (
    <Content
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundPosition,
        padding,
      }}
      id={id}
      $flexDirection={flexDirection}
    >
      <div className="container">{children}</div>
    </Content>
  );
};

export default SectionContainer;
